var _a;
export const ENV_DEV = 'dev';
export const ENV_PREVIEW = 'preview';
export const ENV_LIVE = 'live';
export const APP_ENV = ((_a = process.env.ENVIRONMENT) !== null && _a !== void 0 ? _a : 'dev');
export const MEDIUM_PARAM_NAME = 'm';
export const HOUSE_VALUE_LANDING_PAGE_LAYOUT_TEST_ID = 'market-value-landing-page-layout';
